import { CenteredAppNav } from './CenteredAppNav';
import { DefaultAppNav } from './DefaultAppNav';
import type { AppNavProps } from './types';

/**
 * Render a responsive navigation header at application level. Make sure to wrap
 * it in a `header` element.
 *
 * @remarks
 * Use {@link Layout} with `appNav` instead, which fits better our use cases.
 * @cssVariable --tfd-appnav-height The height of the navigation header
 * @cssVariable --tfd-appnav-z-index The z-index of the navigation header
 * @see https://corgi-x.tfd.engineering/components/appnav
 */
export function AppNav({ children, ...props }: AppNavProps) {
  if ('variant' in props && props.variant === 'centered') {
    return <CenteredAppNav {...props}>{children}</CenteredAppNav>;
  }

  return <DefaultAppNav {...props}>{children}</DefaultAppNav>;
}
